/* eslint-disable */
import * as Types from '../../../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const UserTemplateListDocument = gql`
    query UserTemplateList {
  templateList {
    id
    img
    type
    content
  }
}
    `;

/**
 * __useUserTemplateListQuery__
 *
 * To run a query within a React component, call `useUserTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTemplateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<UserTemplateListQuery, UserTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTemplateListQuery, UserTemplateListQueryVariables>(UserTemplateListDocument, options);
      }
export function useUserTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTemplateListQuery, UserTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTemplateListQuery, UserTemplateListQueryVariables>(UserTemplateListDocument, options);
        }
export function useUserTemplateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserTemplateListQuery, UserTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTemplateListQuery, UserTemplateListQueryVariables>(UserTemplateListDocument, options);
        }
export type UserTemplateListQueryHookResult = ReturnType<typeof useUserTemplateListQuery>;
export type UserTemplateListLazyQueryHookResult = ReturnType<typeof useUserTemplateListLazyQuery>;
export type UserTemplateListSuspenseQueryHookResult = ReturnType<typeof useUserTemplateListSuspenseQuery>;
export type UserTemplateListQueryResult = Apollo.QueryResult<UserTemplateListQuery, UserTemplateListQueryVariables>;
export const LandingPageCategoryDocument = gql`
    query LandingPageCategory($order: String) {
  landingPageCategory(order: $order) {
    id
    title
    pages {
      id
      image
      type
    }
  }
}
    `;

/**
 * __useLandingPageCategoryQuery__
 *
 * To run a query within a React component, call `useLandingPageCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageCategoryQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLandingPageCategoryQuery(baseOptions?: Apollo.QueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>(LandingPageCategoryDocument, options);
      }
export function useLandingPageCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>(LandingPageCategoryDocument, options);
        }
export function useLandingPageCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>(LandingPageCategoryDocument, options);
        }
export type LandingPageCategoryQueryHookResult = ReturnType<typeof useLandingPageCategoryQuery>;
export type LandingPageCategoryLazyQueryHookResult = ReturnType<typeof useLandingPageCategoryLazyQuery>;
export type LandingPageCategorySuspenseQueryHookResult = ReturnType<typeof useLandingPageCategorySuspenseQuery>;
export type LandingPageCategoryQueryResult = Apollo.QueryResult<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>;
export const DuplicateContentPageForCommonPageDocument = gql`
    mutation DuplicateContentPageForCommonPage($idPageFrom: Int!, $idPageTo: Int!) {
  duplicateContentPageForCommonPage(idPageFrom: $idPageFrom, idPageTo: $idPageTo) {
    id
    contentString
  }
}
    `;
export type DuplicateContentPageForCommonPageMutationFn = Apollo.MutationFunction<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>;

/**
 * __useDuplicateContentPageForCommonPageMutation__
 *
 * To run a mutation, you first call `useDuplicateContentPageForCommonPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateContentPageForCommonPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateContentPageForCommonPageMutation, { data, loading, error }] = useDuplicateContentPageForCommonPageMutation({
 *   variables: {
 *      idPageFrom: // value for 'idPageFrom'
 *      idPageTo: // value for 'idPageTo'
 *   },
 * });
 */
export function useDuplicateContentPageForCommonPageMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>(DuplicateContentPageForCommonPageDocument, options);
      }
export type DuplicateContentPageForCommonPageMutationHookResult = ReturnType<typeof useDuplicateContentPageForCommonPageMutation>;
export type DuplicateContentPageForCommonPageMutationResult = Apollo.MutationResult<DuplicateContentPageForCommonPageMutation>;
export type DuplicateContentPageForCommonPageMutationOptions = Apollo.BaseMutationOptions<DuplicateContentPageForCommonPageMutation, DuplicateContentPageForCommonPageMutationVariables>;
export type UserTemplateListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserTemplateListQuery = { __typename?: 'Query', templateList: Array<{ __typename?: 'Template', id?: number | null, img?: string | null, type?: number | null, content?: string | null }> };

export type LandingPageCategoryQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LandingPageCategoryQuery = { __typename?: 'Query', landingPageCategory?: Array<{ __typename?: 'GraphPageCategoryLanding', id?: number | null, title?: string | null, pages: Array<{ __typename?: 'GraphPageLanding', id?: number | null, image?: string | null, type?: number | null }> }> | null };

export type DuplicateContentPageForCommonPageMutationVariables = Types.Exact<{
  idPageFrom: Types.Scalars['Int']['input'];
  idPageTo: Types.Scalars['Int']['input'];
}>;


export type DuplicateContentPageForCommonPageMutation = { __typename?: 'Mutation', duplicateContentPageForCommonPage: { __typename?: 'GraphPage', id?: number | null, contentString: string } };
